import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  leftButton: {
    id: 'listings.all',
    description: 'All events',
    defaultMessage: 'All {currencyCode} events',
  },
  rightButton: {
    id: 'listings.some',
    description: 'Select events',
    defaultMessage: 'Specific {currencyCode} events',
  },
  title: {
    id: 'listing.title',
    description: 'Title of listing',
    defaultMessage: 'Event name',
  },
  status: {
    id: 'listing.status',
    description: 'Status of listing',
    defaultMessage: 'Status',
  },
  date: {
    id: 'listing.date',
    description: 'Start date of listing',
    defaultMessage: 'Date',
  },
  statusCellLive: {
    id: 'listing.live',
    defaultMessage: 'Live',
  },
  statusCellDraft: {
    id: 'listing.draft',
    defaultMessage: 'Draft',
  },
  eventsTitle: {
    id: 'addons.eventsTitle',
    description: 'Events section title',
    defaultMessage: 'Applicable events and ticket types ({currencyCode})',
  },
  eventsSubtitle: {
    id: 'addons.eventsSubtitle',
    description: 'Explain assigning add-ons to listings',
    defaultMessage: 'Select what events and ticket types this add-on applies to.',
  },
  editEventsButton: {
    id: 'addons.editEventsButton',
    description: '',
    defaultMessage: 'Edit events',
  },
  eventsSubtitleSelectedListings: {
    id: 'listing.subtitleSelectedListings',
    defaultMessage: 'This add-on is available on the following events',
  },
  eventsSubtitleAllListingsApplied: {
    id: 'listing.subtitleAllListingsApplied',
    defaultMessage: 'This add-on is available on all {currencyCode} events',
  },
  createEvent: {
    id: 'listings.createEvent',
    defaultMessage: 'Create event',
  },
  noLiveListings: {
    id: 'listings.noLiveListings',
    defaultMessage: 'Oops! Looks like this add-on is not available on any upcoming events.',
  },
  editListingsSubtitle: {
    id: 'listings.editListings',
    defaultMessage: 'Add-on is currently applied to these events:',
  },
  allEventsFilter: {
    id: 'listings.filter.all',
    defaultMessage: 'All',
  },
  liveEventsFilter: {
    id: 'listings.filter.live',
    defaultMessage: 'Live',
  },
  draftEventsFilter: {
    id: 'listings.filter.draft',
    defaultMessage: 'Draft',
  },
  searchPlaceholder: {
    id: 'listings.search.placeholder',
    defaultMessage: 'Search events',    
  },
  noEventsFound: {
    id: 'listings.filter.noEventsFound',
    defaultMessage: 'You don’t have any live or draft {currencyCode} events at this time.\n'
     + 'Once {currencyCode} event is created, it will be displayed in this section.'
  },
  noEventsFoundOnFilters: {
    id: 'listings.filter.noEventsFoundOnFilter',
    defaultMessage: 'No results found\nTry adjusting your search, changing or removing filters.'
  },
  removeAllFilters: {
    id: 'listings.filter.removeAllFilters',
    defaultMessage: 'Remove all filters'    
  },
  selectedEventCounter: {
    id: 'listing.selectedEventCounter',
    defaultMessage: '{listingIdsCount} event selected',
  },
  selectedEventsCounter: {
    id: 'listing.selectedEventsCounter',
    defaultMessage: '{listingIdsCount} events selected',
  }
});
